import type { PeriodFilterValue } from '../components/dashboard/PeriodFilterDropdown';

function formatYMD(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
}

/**
 * Maps dashboard period filter to Wawi sales-overview query params.
 * Backend rule: pass both startDate and endDate, or neither (default: last 30 calendar days).
 */
export function periodValueToWawiSalesOverviewParams(period: PeriodFilterValue): { startDate?: string; endDate?: string } {
  if (period.startDate && period.endDate) {
    return { startDate: period.startDate, endDate: period.endDate };
  }

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  if (period.preset === '30') {
    return {};
  }

  if (period.preset === 'today') {
    const d = formatYMD(today);
    return { startDate: d, endDate: d };
  }

  if (period.preset === '7') {
    const end = new Date(today);
    const start = new Date(today);
    start.setDate(start.getDate() - 6);
    return { startDate: formatYMD(start), endDate: formatYMD(end) };
  }

  if (period.preset === 'this_month') {
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    return { startDate: formatYMD(start), endDate: formatYMD(today) };
  }

  if (period.preset === 'last_month') {
    const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const end = new Date(now.getFullYear(), now.getMonth(), 0);
    return { startDate: formatYMD(start), endDate: formatYMD(end) };
  }

  if (period.preset === 'this_year') {
    const start = new Date(now.getFullYear(), 0, 1);
    return { startDate: formatYMD(start), endDate: formatYMD(today) };
  }

  return {};
}
